@if (deviceCardData()?.length) {
  <section class="customer-side-panel-wrapper">
    <h1 class="customer-side-panel-header-title">{{ associatedDevicesTitle | translate }}</h1>
    <div class="filter-wrapper">
      <ui-dropdown-list
        class="filter__dropdown"
        [style.max-width]="accountNumbersFilterModel().width + 'px'"
        [title]="accountNumbersFilterModel().title | translate"
        [selected]="accountNumbersFilterModel().selected[0]"
        [items]="accountNumbersFilterModelTranslated()"
        (valueChange)="onAccountNumberChange($event)"
      />
      <ui-dropdown-list
        class="filter__dropdown"
        [style.max-width]="deviceStatusFilterModel.width + 'px'"
        [title]="deviceStatusFilterModel.title | translate"
        [selected]="deviceStatusFilterModel.selected[0]"
        [items]="deviceStatusFilterModelTranslated()"
        (valueChange)="onDeviceStatusChange($event)"
      />
    </div>
    <div
      #sidePanelBody
      class="customer-side-body f-column gap-05"
    >
      @for (associatedDevice of filteredAssociatedDevicesCardData$ | async; track associatedDevice.deviceUID) {
        <aos-device-card
          [device]="associatedDevice"
          [showLocation]="true"
          [showComment]="true"
        />
      }
    </div>
  </section>
}
